import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-comment_edit",
  "use": "icon-comment_edit-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-comment_edit\"><defs><style>#icon-comment_edit .a{fill:none;fill-rule:evenodd;}#icon-comment_edit .b{fill:#4e5969;}</style></defs><path class=\"a\" d=\"M0,0H14V14H0Z\" /><path class=\"b\" d=\"M3.741,9.333,9.658,3.417l-.825-.825L2.917,8.509v.825ZM4.225,10.5H1.75V8.025l6.67-6.67a.583.583,0,0,1,.825,0L10.9,3a.583.583,0,0,1,0,.825ZM1.75,11.667h10.5v1.167H1.75Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol